module.exports = __webpack_public_path__ + "img/modal-border-bottom.d0babc7d.svg";